import RadioButtons from "../../components/RadioButtons";

function StepThree() {
	return (
		<div className="flex w-full gap-3 items-center justify-center mb-4">
			<RadioButtons />
		</div>
	);
}

export default StepThree;
